import icon from 'assets/img/icons/empty-card-packs.svg'

const CardPacksEmpty = () => {
  return (
    <div className="empty-packs">
      <img src={icon} className="empty-packs__pic" alt="" />
      <h2 className="empty-packs__title">No Card packs</h2>
    </div>
  )
}

export default CardPacksEmpty;
